const s = {
  name: "Certificate",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,7h20V5H5V7z"/>
		<path class="st0" d="M25,12H5v-2h20V12z"/>
		<path class="st0" d="M5,17h20v-2H5V17z"/>
		<path class="st0" d="M5,22h20v-2H5V22z"/>
		<path class="st0" d="M13,27H5v-2h8V27z"/>
		<path class="st0" d="M5,32h8v-2H5V32z"/>
		<path class="st0" d="M21,24c-2.8,0-5,2.2-5,5c0,2.2,1.5,4.1,3.5,4.8l-1.4,2.8l1.8,0.9l1.1-2.2l1.1,2.2l1.8-0.9l-1.4-2.8
			c2-0.6,3.5-2.5,3.5-4.8C26,26.2,23.8,24,21,24z M18,29c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.7-1.3,3-3,3S18,30.7,18,29z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h24c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.4,2,2,2.4,2,3v34
			c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Certificate
};
